import { createModelSchema, primitive } from 'serializr';
import { optional } from '@vromo/models';

export class Rating {
    
    id?: number | null = null;
    created?: number | null = null;
    comment: string | null = null;
    ratio = 0;
}

createModelSchema(Rating, {
    id: optional(primitive()),
    created: optional(primitive()),
    comment: optional(primitive()),
    ratio: primitive()
});
